// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-font-color":"#000000","description":"_3RpV77_"};